import * as actionTypes from './actionTypes';
import { submitTaskApi,getTaskConfigApi } from '../../apiUtils/api';

export const selectedImageCate=()=>{
    return { type: actionTypes.IMGCATE_TYPE_SELECTED };
}

export const deselectedImageCate=()=>{
    return { type: actionTypes.IMGCATE_TYPE_DESELECTED };
}

export const updateAnswer=(imgCateForm)=>{
    return { type: actionTypes.IMGCATE_UPDATE_ANSWER,imgCateForm: imgCateForm};
}

export const openLightBox=()=>{
    return { type: actionTypes.IMGCATE_OPEN_LIGHTBOX };
}

export const closeLightBox=()=>{
    return { type: actionTypes.IMGCATE_CLOSE_LIGHTBOX };
}

export const submitResult=(jwt,imgCateForm,taskAcceptedInfoId,imgCate)=>{
    let allAnswer={};
    
    if (!imgCateForm.hasNone || !imgCateForm.imageNotLoad){
        imgCate.imgCateQuestions.map(question => {
            let answers = []
            question.answers.map(answer=>{
                if (imgCateForm[answer.field]){
                    if (answer.subAnswers && answer.subAnswers.length > 0){
                        answer.subAnswers.map(subAnswer=>{
                            if (imgCateForm[subAnswer.field]){
                                if (subAnswer.subAnswers && subAnswer.subAnswers.length > 0){
                                    subAnswer.subAnswers.map(thirdSubAnswer=>{
                                        if (imgCateForm[thirdSubAnswer.field]){
                                            if (thirdSubAnswer.subAnswers && thirdSubAnswer.subAnswers.length > 0 ){
                                                thirdSubAnswer.subAnswers.map(fourthAnswer => {
                                                    if (imgCateForm[fourthAnswer.field]){
                                                        //Layer 4 answer
                                                        answers.push(fourthAnswer)
                                                    }
                                                })
                                            }else {
                                                //Layer 3 answer
                                                answers.push(thirdSubAnswer)
                                            }
                                        }
                                    })
                                }else {
                                    //Layer 2 answer
                                    answers.push(subAnswer)
                                }
                            }
                        })
                    }else {
                        //Layer 1 answer
                        answers.push(answer)
                    }
                }
            })

            allAnswer[question.type] = answers
        })
    }

    let payload={};
    payload.answer=JSON.stringify(allAnswer);
    payload.taskAcceptedInfoId=taskAcceptedInfoId;
    payload.imgNotLoad=imgCateForm.imageNotLoad;
   
    return dispatch => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.IMGCATE_SUBMIT_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.IMGCATE_SUBMIT_SUCCESS, answer: payload.answer });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.IMGCATE_SUBMIT_ERROR, error: err});
    })
}

export const submitCompleted=()=>{
    return { type: actionTypes.IMGCATE_SUBMIT_COMPLETED };
}

export const getTaskConfig=(jwt,taskAcceptedInfoId)=>{
    return dispatch => getTaskConfigApi(jwt,taskAcceptedInfoId).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.IMGCATE_GET_TASK_CONF_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.IMGCATE_GET_TASK_CONF_SUCCESS, task: data.task });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.IMGCATE_GET_TASK_CONF_ERROR, error: err});
    })
}

export const updateImgCateQuestions=(task)=>{
    const taskParamValues=task.task_param_values;
    const imgCateQuestions = JSON.parse(taskParamValues);
    return { type: actionTypes.IMGCATE_UPDATE_QUETIONS, imgCateQuestions };
}


// WEBPACK FOOTER //
// ./src/redux/imgCate/actions.js